import { WizardStep, WizardStepIndex } from "../../../shared/enums/WizardStep";
import { linkHelper } from "../../../shared/helpers/linkHelper";
import StepActive from "./StepActive";
import StepDone from "./StepDone";
import StepInactive from "./StepInactive";

interface OtherOptionsStepItemProps {
  activeStepIndex: number;
  market: string;
  text: string;
}

const OptionalStepItem = ({
  activeStepIndex,
  market,
  text,
}: OtherOptionsStepItemProps) => {
  const stepNumber = WizardStepIndex.Optional + 1;
  const hideMobile =
    activeStepIndex < WizardStepIndex.Product ? "hideStep" : "";

  if (activeStepIndex === WizardStepIndex.Optional) {
    return (
      <StepActive
        hideMobilClass={hideMobile}
        stepNumber={stepNumber}
        text={text}
      />
    );
  }

  if (activeStepIndex < WizardStepIndex.Optional) {
    return (
      <StepInactive
        hideMobilClass={hideMobile}
        stepNumber={stepNumber}
        text={text}
      />
    );
  }

  const url = linkHelper.link(WizardStep.Optional, market);
  return <StepDone hideMobilClass={hideMobile} text={text} url={url} />;
};

export default OptionalStepItem;
